export default {
  PO_REJECT_FILENAME: 'fileName',
  PO_REJECT_EVENTCREATETS: 'eventCreateTS',
  PO_REJECT_EVENTSTATUS: 'eventStatus',
  PO_REJECT_RECEIVEDITEMS: 'receivedItems',
  PO_REJECT_ERRORSFOUNDCOUNT: 'errorsFoundCount',
  PO_REJECT_EVENTERRORLIST: 'eventErrorList'
};
